import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import ProtectedRoute from "./ProtectedRoute";
import Unauthorized from "./Unauthorized";
import Dashboard from "../components/Dashboard";
import Navbar from "../components/Navbar";
import store from "../store";
import { Provider } from "react-redux";
import "../../src/App.css";
import UserAccount from "../pages/UserAccount/UserAccount";
import PanelVariable from "../pages/Panel/PanelVariable";
import Points from "../pages/Points/Points";
import Referral from "../pages/Referral/Referral";
import Profile from "../pages/Profile/Profile";
import AccessManager from "../pages/AccessManager/AccessManager";
import Location from "../pages/Location/Location";
import SurveyHistory from "../pages/SurveyHistory/SurveyHistory";
import HelpAndSupport from "../pages/HelpAndSupport/HelpAndSupport";
import TransactionHistory from "../pages/TransactionHistory/TransactionHistory";
import Redeem from "../pages/Redeem/Redeem";
import BlackList from "../pages/PanelistQuality/BlackList/BlackList";
import PanelUser from "../pages/PanelUser/PanelUser";
import PanelUserDetail from "../pages/PanelUser/PanelUserDetail";
import Loader from "@/components/Loader";
import HomeDetailed from "../pages/Home/HomeDetailed";
import PanelistQuality from "@/pages/PanelistQuality/PanelistQuality";
import JoinSource from "@/pages/JoinSource/JoinSource";
import SetPassword from "@/pages/SetPassword/SetPassword";
import ForgotPassword from "@/pages/ForgotPassword/ForgotPasswod";
import UserBio from "@/pages/UserBio/UserBio";

// import '../components/css/swalFire.css'

const Login = React.lazy(() => import("./Login"));
const Home = React.lazy(() => import("../pages/Home/Home"));
const NotFound = React.lazy(() => import("../NotFound"));

const App = () => (
  <Provider store={store}>
    <AuthProvider>
      <BrowserRouter>
        <Suspense
          fallback={
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
              }}
            >
              <Loader />
            </div>
          }
        >
          <ProtectedRoute>
            <Navbar />
          </ProtectedRoute>

          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/user-bio"
              element={
                <ProtectedRoute>
                  <UserBio />
                </ProtectedRoute>
              }
            />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />

            <Route
              path="/:country"
              element={
                <ProtectedRoute>
                  <HomeDetailed />
                </ProtectedRoute>
              }
            />
            <Route
              path="/points"
              element={
                <ProtectedRoute>
                  <Points />
                </ProtectedRoute>
              }
            />
            <Route
              path="/user-account"
              element={
                <ProtectedRoute>
                  <UserAccount />
                </ProtectedRoute>
              }
            />
            <Route
              path="/survey-history"
              element={
                <ProtectedRoute>
                  <SurveyHistory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/panel-variable"
              element={
                <ProtectedRoute>
                  <PanelVariable />
                </ProtectedRoute>
              }
            />

            <Route
              path="/panelist-quality"
              element={
                <ProtectedRoute>
                  <PanelistQuality />
                </ProtectedRoute>
              }
            />

            <Route
              path="/access-manager"
              element={
                <ProtectedRoute>
                  <AccessManager />
                </ProtectedRoute>
              }
            />

            <Route
              path="/location"
              element={
                <ProtectedRoute>
                  <Location />
                </ProtectedRoute>
              }
            />
            <Route
              path="/referral"
              element={
                <ProtectedRoute>
                  <Referral />
                </ProtectedRoute>
              }
            />

            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />

            <Route
              path="/support"
              element={
                <ProtectedRoute>
                  <HelpAndSupport />
                </ProtectedRoute>
              }
            />

            <Route
              path="/panel-user"
              element={
                <ProtectedRoute>
                  <PanelUser />
                </ProtectedRoute>
              }
            />

            <Route
              path="/panel-user/:id"
              element={
                <ProtectedRoute>
                  <PanelUserDetail />
                </ProtectedRoute>
              }
            />

            <Route
              path="/transaction"
              element={
                <ProtectedRoute>
                  <TransactionHistory />
                </ProtectedRoute>
              }
            />

            <Route
              path="/redeem"
              element={
                <ProtectedRoute>
                  <Redeem />
                </ProtectedRoute>
              }
            />

            <Route
              path="/blacklist"
              element={
                <ProtectedRoute>
                  <BlackList />
                </ProtectedRoute>
              }
            />

            <Route
              path="/join-source"
              element={
                <ProtectedRoute>
                  <JoinSource />
                </ProtectedRoute>
              }
            />

            <Route path="/set-password/:uid/:token" element={<SetPassword />} />

            <Route
              path="/forgotpassword/:uid/:token"
              element={<ForgotPassword />}
            />

            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute requiredRoles={["admin"]}>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="*"
              element={
                <ProtectedRoute>
                  <NotFound />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </AuthProvider>
  </Provider>
);

export default App;
